import axios from 'axios';

var getAgendaItems = function getAgendaItems(groupId, meetingId) {
  return axios.get('/groups/' + groupId + '/meetings/' + meetingId);
}; // agendaItems are stored in a json column inside the meeting table.


var updateMeetingAgendaItems = function updateMeetingAgendaItems(groupId, meetingId, request) {
  return axios.put("/groups/".concat(groupId, "/meetings/").concat(meetingId, "/agenda-items"), request);
};

var saveAgendaItemsAttachments = function saveAgendaItemsAttachments(groupId, meetingId, request) {
  return axios.post("/groups/".concat(groupId, "/meetings/").concat(meetingId, "/agenda-items-attachments"), request, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};

export { getAgendaItems, updateMeetingAgendaItems, saveAgendaItemsAttachments };